const translations = {
  "en": {
    "Answers built on your unique history.": "Answers built on your unique history.",
    "Chats & Alerts": "Chats & Alerts",
    "Deep Reports": "Deep Reports",
    "Ed's Picks": "Ed's Picks",
    "Flags risks before they land": "Flags risks before they land",
    "Monitors your portfolio while you're away": "Monitors your portfolio while you're away",
    "We've known each other for %{var0} days!": "We've known each other for %{var0} days!",
    "Your %{var0} expires in %{var1} days.": "Your %{var0} expires in %{var1} days.",
    "Your %{var0} expires in 1 day.": "Your %{var0} expires in 1 day.",
    "Your trial ends tomorrow. Here’s a look at what we accomplished together.": "Your trial ends tomorrow. Here’s a look at what we accomplished together."
  },
  "zh-tw": {
    "Answers built on your unique history.": "基於你獨特歷程的解答。",
    "Chats & Alerts": "對話與提醒",
    "Deep Reports": "深度報告",
    "Ed's Picks": "Ed 的精選",
    "Flags risks before they land": "在問題發生前標示風險",
    "Monitors your portfolio while you're away": "在你離開期間監控你的投資組合",
    "We've known each other for %{var0} days!": "我們認識已經 %{var0} 天了！",
    "Your %{var0} expires in %{var1} days.": "你的 %{var0} 還有 %{var1} 天到期。",
    "Your %{var0} expires in 1 day.": "你的 %{var0} 將於 1 天後到期。",
    "Your trial ends tomorrow. Here’s a look at what we accomplished together.": "你的試用期將於明天結束。一起看看我們完成了哪些事。"
  }
};

export default translations;
